<template>
    <div class="puzzles-item-wrapper">
        <div class="puzzles-inner puzzles-inner-my" :class="{
            'puzzles-select-mode': selected.length > 0,
            'puzzles-inner-open': showContext
        }">
            <div @click="handleOpenModal" ref="contextButton" class="puzzles-image puzzles-image-my" :style="{
                'background-image':
                    myPuzzle.blurred ?
                        'url(' + myPuzzle.blurred + ')' :
                        ''
            }">
                <div class="puzzles-image-original" :style="{
                    'background-image':
                        myPuzzle.image ?
                            'url(' + myPuzzle.image + ')' :
                            ''
                }"></div>
            </div>

            <div class="puzzles-select-button" v-if="editingMode"
                :class="{ 'puzzles-select-selected': selected.indexOf(myPuzzle.id) >= 0 }" @click="select">
            </div>

        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PuzzleDetails from "@/components/Modals/PuzzleDetails";
import SvgIcon from "@/components/SvgSprite";

export default {
    name: 'MyPuzzlesItem',
    props: {
        myPuzzle: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        editingMode: {
            type: Boolean,
            required: true
        },
        cancelSelection: Function,
        selected: Array,
    },
    inject: ["setCurrentPuzzleItem"],
    components: {
        SvgIcon,
        PuzzleDetails,
    },

    mixins: [],
    data() {
        return {
            showContext: false,
            showModal: false,
            isSelected: false
        }
    },
    computed: {
        ...mapGetters({
            selected: 'myPuzzles/fetchMyPuzzlesSelected',
            myPuzzles: 'myPuzzles/fetchMyPuzzles',
            initIsEmpty: "init/isEmpty",
            userIsEmpty: "user/isEmpty",
        }),

        instancesIsEmpty() {
            return this.$store.getters[this.getMethod() + "/isEmpty"];
        },
        commentsIsEmpty() {
            return this.$store.getters[this.getCommentsMethod() + "/isEmpty"];
        },
        comments() {
            return this.$store.getters[
                this.getCommentsMethod() +
                "/fetch" +
                this.getMethod(true, "", false) +
                "Comments"
            ];
        },
        commentsErrors() {
            return this.$store.getters[this.getCommentsMethod() + "/errors"];
        },
        commentsIsEmpty() {
            return this.$store.getters[this.getCommentsMethod() + "/isEmpty"];
        },
        nextComments() {
            return this.$store.getters[
                this.getCommentsMethod() +
                "/fetch" +
                this.getMethod(true, "", false) +
                "CommentsNext"
            ];
        },
    },
    methods: {
        clickOutsideContext() {
            this.showContext = false;
        },
        handleOpenModal() {
            this.setCurrentPuzzleItem(this.myPuzzle);
        },
        openModal() {
            this.$modal.show("PuzzleDetails", {
                id: this.myPuzzle.id,
                feed: false,
                isVideo: false,
            });
        },

        select() {
            this.showModal = false;

            this.showContext = false;
            this.$store.dispatch("myPuzzles/select", this.myPuzzle.id);
        },
        clickOutsideContext() {
            this.showContext = false;
        },
        getVerbalDate(timestamp) {
            const date = new Date(timestamp);

            const day = date.getDate();
            const month = date.toLocaleString("default", { month: "long" });
            const time = date.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
            });

            return `${day} ${month} в ${time}`;
        },
        getCommentsMethod(method = "") {
            return (this.isVideo ? "videoComments" : "comments") + method;
        },
    }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/pages/_puzzles';
</style>

<style>
.puzzles-item-actions {
    display: flex !important;
}

.puzzles-image-my:hover .puzzles-image-original {
    display: block;
}

.puzzles-image-original {
    display: none;
}
</style>
